type SlugifyOptions = {
  lowercase?: boolean;
};

const defaultOptions: SlugifyOptions = {
  lowercase: true,
};

export function slugify(text: string, options: SlugifyOptions = {}) {
  const { lowercase } = { ...defaultOptions, ...options };
  let result = text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

  if (lowercase ?? false) {
    result = result.toLowerCase();
  }

  return result;
}
